module.exports = __webpack_public_path__ + "img/noti-fail2.262d7fbc.svg";